import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'; // 引入 VueI18n

// 引入 Element UI 组件和 Message, MessageBox, Tooltip 方法/组件
import {
  Button,
  Container,
  Aside,
  Main,
  Header,
  Menu,
  MenuItem,
  Input,
  Scrollbar,
  Form,
  FormItem,
  Message,
  MessageBox, // 导入 MessageBox 组件
  Tooltip,     // 导入 Tooltip 组件 (用于指令)
  Dropdown,    // 导入 Dropdown 组件 (用于语言切换)
  DropdownMenu, // 导入 DropdownMenu 组件
  DropdownItem // 导入 DropdownItem 组件
} from 'element-ui';
// 引入 Element UI 的主样式文件
import 'element-ui/lib/theme-chalk/index.css';

// 引入 Element UI 各语言包
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import frLocale from 'element-ui/lib/locale/lang/fr';
import jaLocale from 'element-ui/lib/locale/lang/ja';

// 引入 Element UI 的国际化配置工具
import ElementLocale from 'element-ui/lib/locale'; // <-- 添加了这一行

// 引入自定义语言文件
import messages from './locales'; // 引入你创建的语言文件

// Element UI 语言包映射，用于根据语言代码获取对应的 Element UI 语言包
const elementUILocales = {
  'en': enLocale,
  'zh': zhLocale, // Element UI 中文是 zh-CN
  'fr': frLocale,
  'ja': jaLocale,
};


Vue.use(VueI18n); // 安装 VueI18n 插件

// 尝试获取用户先前保存的语言
let savedLang = localStorage.getItem('language');

// 获取用户的系统语言，只获取主要部分（例如，从‘zh-CN’获取‘zh’）
const browserSystemLang = navigator.language ? navigator.language.split('-')[0] : '';

// 定义我们系统支持的语言列表
const supportedLangs = ['en', 'zh'];

// 确定实际要使用的系统语言：如果浏览器系统语言在支持列表中，则使用它；否则，为空字符串
const systemLang = supportedLangs.includes(browserSystemLang) ? browserSystemLang : '';

// 确定最终语言，优先级：有效的系统语言 -> 保存的语言 -> 默认英语
savedLang = systemLang || savedLang || 'en';

// --- 真正的 Bug 修复在这里 ---
// 在 i18n 实例创建前，将确定的语言存回 localStorage
// 这样 api.js 中的请求拦截器就能在第一时间获取到正确的语言
localStorage.setItem('language', savedLang);
// --- 修复结束 ---

// 创建 VueI18n 实例
const i18n = new VueI18n({
  locale: savedLang, // 设置默认语言
  messages, // 设置语言包
});

// 配置 Element UI 使用当前的语言
const elLocale = elementUILocales[savedLang] || enLocale;
ElementLocale.use(elLocale);


// 注册 Element UI 组件
Vue.use(Button);
Vue.use(Container);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Header);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Input);
Vue.use(Scrollbar);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Dropdown); // 注册 Dropdown
Vue.use(DropdownMenu); // 注册 DropdownMenu
Vue.use(DropdownItem); // 注册 DropdownItem


// 将 Message 方法挂载到 Vue 原型上方便调用
Vue.prototype.$message = Message;

// ** 全局注册 MessageBox 的方法 ($alert, $confirm, $prompt) **
Vue.prototype.$msgbox = MessageBox; // 可选：注册 $msgbox
['alert', 'confirm', 'prompt'].forEach(type => {
  // 注意：Element UI 的 MessageBox 方法本身支持 i18n，
  // 通过 VueI18n 实例传入即可，无需在此处额外处理文本
  Vue.prototype['$' + type] = MessageBox[type];
});

// ** 全局注册 el-tooltip 指令 **
Vue.directive('el-tooltip', Tooltip.directive); // 注册 el-tooltip 指令


Vue.config.productionTip = false

new Vue({
  router,
  i18n, // 将 i18n 实例注入到 Vue 根实例
  render: h => h(App)
}).$mount('#app')